import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import BaseStats from './modules/BaseStats'
import CurrGoodsDetail from './modules/CurrGoodsDetail'
import ShoppingData from './modules/ShoppingData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // 本应用的基本数据
    BaseStats,

    // 购物车数据
    cart,

    // 当前打开商品的详细信息
    CurrGoodsDetail,

    // 下单数据
    ShoppingData
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js